var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { parse } from "query-string";
import * as React from 'react';
import { Button, Dimmer, Form, Input, Loader, Message } from "semantic-ui-react";
import { API_SVC_BASE_URL } from "./Config";
import { baseHeaders, fetchWrapper } from "./RequestHelpers";
var OrderUploadPoPage = /** @class */ (function (_super) {
    __extends(OrderUploadPoPage, _super);
    function OrderUploadPoPage(props) {
        var _this = _super.call(this, props) || this;
        _this.selectedFile = function (event, data) {
            var list = event.currentTarget.files;
            if (list === null || list.length === 0) {
                return;
            }
            _this.setState({
                file: list[0]
            });
        };
        _this.onPoNumChange = function (event, data) {
            var str = data.value;
            _this.setState({
                poNum: str
            });
        };
        _this.onNoteChange = function (event, data) {
            var str = data.value;
            _this.setState({
                note: str
            });
        };
        _this.onSubmit = function () {
            _this.setState({
                loading: true,
                submitError: false,
                urlParseError: false,
                success: false
            }, function () {
                var headers = new Headers(baseHeaders);
                headers.set('authorization', "Basic " + btoa('OAT$' + _this.state.tokenId + ':' + _this.state.tokenSecret));
                var formData = new FormData();
                formData.append('file', _this.state.file);
                var json = JSON.stringify({
                    note: _this.state.note,
                    poNum: _this.state.poNum
                });
                formData.append('json', json);
                fetchWrapper(API_SVC_BASE_URL + '/orders/attachment/purchase-order', {
                    headers: headers,
                    method: 'POST',
                    body: formData
                }).then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            success: true,
                            loading: false
                        });
                    }
                    else {
                        _this.setState({
                            submitError: true,
                            loading: false
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't submit purchase order: " + rej);
                });
            });
        };
        var search = parse(props.history.location.search);
        var urlParseError = false;
        if (!('tokenId' in search && 'tokenSecret' in search)) {
            urlParseError = true;
        }
        _this.state = {
            file: undefined,
            loading: false,
            submitError: false,
            success: false,
            tokenId: ('tokenId' in search && typeof search.tokenId === 'string') ? search.tokenId : '',
            tokenSecret: ('tokenSecret' in search && typeof search.tokenSecret === 'string') ? search.tokenSecret : '',
            urlParseError: urlParseError,
            note: '',
            poNum: ''
        };
        return _this;
    }
    OrderUploadPoPage.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { id: "non-header-portion", as: Form, error: this.state.submitError || this.state.urlParseError, success: this.state.success },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                this.state.urlParseError
                    && React.createElement(Message, { negative: true }, "Invalid link."),
                React.createElement(Form.Field, { required: true },
                    React.createElement("label", null, "Purchase order PDF"),
                    React.createElement(Input, { accept: '.pdf', onChange: this.selectedFile, type: 'file' })),
                React.createElement(Form.Field, { required: true },
                    React.createElement("label", null, "PO Number"),
                    React.createElement(Input, { value: this.state.poNum, onChange: this.onPoNumChange })),
                React.createElement(Form.Field, null,
                    React.createElement("label", null, "Note"),
                    React.createElement(Input, { value: this.state.note, onChange: this.onNoteChange })),
                this.state.submitError
                    && React.createElement(Message, { negative: true }, "Could not submit form."),
                this.state.success
                    && React.createElement(Message, { positive: true }, "Your file was successfully uploaded."),
                React.createElement(Button, { disabled: this.state.success || this.state.file === undefined || this.state.poNum === '', icon: 'upload', type: 'submit', label: 'Upload', labelPosition: 'left', onClick: this.onSubmit })));
    };
    return OrderUploadPoPage;
}(React.PureComponent));
export default OrderUploadPoPage;
//# sourceMappingURL=OrderUploadPoPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/OrderUploadPoPage.js
// module id = 1270
// module chunks = 0